// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__3bScj","header":"ReportDetails_header__hetvu","title":"ReportDetails_title__31bMV","left":"ReportDetails_left__1MktF"};